import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TUNISIAN_GOVERNORATES } from '@erp/data-access/interfaces';

export interface GovernorateOption {
  /** Valeur STOCKÉE : toujours le nom français. C'est une chaîne stable,
   *  imprimée telle quelle sur les documents et les PDF, et qui ne change pas
   *  quand l'utilisateur bascule la langue de l'interface. */
  value: string;
  /** Libellé AFFICHÉ, dans la langue de l'interface (arabe en AR). */
  label: string;
}

/** Les 24 gouvernorats tunisiens, libellés dans la langue courante.
 *  Source unique pour tous les champs « wilaya / gouvernorat » de l'espace
 *  électricien (inscription, clients, livraison). */
export function useGovernorateOptions(): GovernorateOption[] {
  const { i18n } = useTranslation();
  const isAr = (i18n.language ?? '').startsWith('ar');
  return useMemo(
    () =>
      TUNISIAN_GOVERNORATES.map((g) => ({
        value: g.nameFr,
        label: isAr ? g.nameAr : g.nameFr,
      })),
    [isAr],
  );
}

/** Le nom donné fait-il partie des 24 gouvernorats ? Sert à garder
 *  sélectionnable une ville libre héritée d'une ancienne saisie. */
export function isKnownGovernorate(nameFr: string): boolean {
  return TUNISIAN_GOVERNORATES.some((g) => g.nameFr === nameFr);
}
